import { render, staticRenderFns } from "./inputSelect.vue?vue&type=template&id=3dd20fbe&scoped=true"
import script from "./inputSelect.vue?vue&type=script&lang=js"
export * from "./inputSelect.vue?vue&type=script&lang=js"
import style0 from "./inputSelect.vue?vue&type=style&index=0&id=3dd20fbe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd20fbe",
  null
  
)

export default component.exports